module.exports = __webpack_public_path__ + "fonts/circular-black.8b715e1.woff";